<template lang="pug">
div
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Denominação")
        app-label(label="Denominação:", :required="true")
        el-input.input(
          v-model="cadastro.imovel.denominacao",
          name='Denominação',
          maxlength="300",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Município")
        app-label( label="Município:", :required="true")
        el-select.input(
          class="select",
          v-model="cadastro.imovel.municipio",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          value-key="id",
          name="Município",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="8")
      validation-provider(rules="required|min_value:0.00001", v-slot="{ errors }", name="Imóvel/Área")
        app-label(label="Área:", :required="true")
        app-double-input.input(
          v-model="cadastro.imovel.area",
          name='Área',
          :precision="4",
          :onkeypress="onlyInputNumbers",
          :class="{'erro' : errors.length}",
          :showAppend ="true"
        )
        span.help.erro {{ errors[0] }}

  app-matricula-imovel(
    :imovel="cadastro.imovel"
    :required="true",
  )

  app-divider(label="Dados do Título")
  el-row(:gutter="30")
    el-col.inputDiv(:span="12")
      app-label(label="Nome do beneficiário:", :required="false")
      el-input.input(
        v-model="cadastro.imovel.nomeBeneficiarioTitulo",
        maxlength="300"
        name='Nome do beneficiário',
      )
  app-documentos(
    :maxSize="25",
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Imóvel"
  )
</template>

<script>
import AppImovelDenominacao from '../../../../components/cadastro/AppImovelDenominacao'
import AppImovelDadosTitulo from '../../../../components/cadastro/AppImovelDadosTitulo'
import AppMatriculaImovel from '../../../../components/AppMatriculaImovel'
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDoubleInput from '@/components/AppDoubleInput'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'

export default {
  mixins: [onlyInputNumbers],

  components: {
    AppImovelDenominacao,
    AppMatriculaImovel,
    AppImovelDadosTitulo,
    AppDocumentos,
    AppLabel,
    AppDivider,
    AppDoubleInput
  },

  props: ['cadastro', 'observer'],

  data () {
    return {
      documentos: [],
      documentosObrigatorios: [],
      municipios: []
    }
  },

  async beforeRouteLeave (to, from, next) {
    this.documentos = await this.findDocumentos('imovelTransferenciaDireito')
    this.documentosObrigatorios = await this.findDocumentos('obrigatorios/imovelTransferenciaDireito')
    await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    next()
  },

  async created () {
    this.documentos = await this.findDocumentos('imovelTransferenciaDireito')
    this.documentosObrigatorios = await this.findDocumentos('obrigatorios/imovelTransferenciaDireito')
    this.getMunicipiosByUf()
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/transferenciaDireito/components/Imovel.vue